/**
 * Extension for okPopupBox to add button press sound
 */
okPopupBoxExtension = {};

okPopupBoxExtension.setupButtonSound = function () {
  try {
    const button = resourceManager.get('okPopupBox:button');

    if (button && button.onPressedCallback !== undefined) {
      const originalCallback = button.onPressedCallback;

      // Wrap the original callback to add sound
      button.onPressedCallback = function () {
        soundManager.play('buttonPressed');

        if (originalCallback) {
          originalCallback.apply(this, arguments);
        }
      };
    }
  } catch (error) {
    console.log('OkPopupBoxExtension: Error:', error);
  }
};

messageBus.subscribe('spinner:GameConfigEvent', okPopupBoxExtension.setupButtonSound);
